import { useNavigate } from 'react-router-dom';
import { notification } from 'antd';
import { useFetch } from './useFetch';
import { useForm } from './useForm';

export const useNotification = () => {
    const fetch = useFetch();
    const [form] = useForm();
    const navigate = useNavigate();

    const save = async (values: Record<string, any>) => {
        const response = await fetch.request({
            url: '/notifications/create',
            method: 'post',
            data: values,
        });
        if (response.success) {
            notification.success({
                message: response.message,
            });
            navigate('/notifications');
        }
    };

    return {
        form,
        loading: fetch.loading,
        save,
    };
};
